// eslint-disable-next-line @typescript-eslint/comma-dangle
export enum Position {
  LEFT = 'left',
  RIGHT = 'right',
}
